export default {
  "content": "<title>Icons/Consolidated</title><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DFF5EF\" cx=\"24\" cy=\"24\" r=\"24\"/><circle stroke=\"#5D2193\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" cx=\"24\" cy=\"24\" r=\"10\"/><path d=\"M22 27v-6M26 27v-6\" stroke=\"#5D2193\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};